<template>
  <Modal :id="'cmp-settings-label-price-list-form'" @cancelled="onCancel" :loadingFlag="loadingFlag">
    <template slot="header">{{title}} {{$t('price')}}</template>
    <template slot="body">
      <div class="form-group">
        <TextField
          class="m1"
          :id="'price_list_name'"
          v-bind="textFieldConfig"
          required
          :showValidationIcons="true"
          :immediateValidation="true"
          :value="price_list.price_list_name"
          :placeholder="$t('name')"
          @valuechanged="onTextFieldValueChange"
          @validated="(e, vr) => onValidationDone('price_list', vr)"
        ></TextField>
        <Dropdown
          :options="currenciesTV"
          class="m2"
          :selected="currenciesTV.find(e => e.value == price_list.currency_id)"
          :placeholder="$t('currency')"
          v-on:selectedChange="e => onDropdownChange('currency_id', e)"
          :listHeight="95"
          box
        ></Dropdown>
      </div>
      <div class="dt-modal--subtitle">
        {{$t('price_codes')}}
      </div>
      <NTable
        class="related_codes_list"
        :items="related_codes_with_new || []"
        :config="createNTableConfig({
          rowHeight: 30,
          showHeader: false
        })"
      >
        <template v-slot:item="{ item }">
          <tr>
            <td class="tax_name">
              <Dropdown
                :options="price_codesTV"
                class="m2"
                :selected="price_codesTV.find(e => e.value == item.price_code_id)"
                :placeholder="$t('price')"
                v-on:selectedChange="e => onPriceCodeChange(item, 'price_code_id', e)"
                :listHeight="95"
              ></Dropdown>
            </td>
            <td class="price">
              <input
                  type="text"
                  class="ntable--textfield"
                  :name="`price-${item['price_code_id']}`"
                  :id="`price-${item['price_code_id']}`"
                  :placeholder="$t('price')"
                  :value="item['price']"
                  v-on:blur="e => onTextInputBlur(item, 'price', e )"
                />
            </td>
            <td class="option" style="max-width: 40px">
              <div class="dt-icon-container">
                <img
                  src="static/icons/delete.svg"
                  class="dt-icon v5 s1"
                  @click="e => onDeletePriceCode(item)"
                  :alt="$t('remove_price_list')"
                  :title="$t('remove_price_list')"
                />
              </div>
            </td>
          </tr>
        </template>
      </NTable>
      <button style="margin-top: 10px" class="dt-button s6" @click.stop="addAllPriceCodes">{{$t('all_pricelists')}}</button>
    </template>
    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel">{{$t('cancel')}}</button>
      <button
        @click.stop="onFormSubmit"
        class="dt-button v1 s6"
        :class="{
          'disabled': !isFormValid(),
        }"
        :disabled="!isFormValid()"
      >{{$t('ok')}}</button>
    </template>
  </Modal>
</template>

<script>
import Modal from "@dtplugins/modal/modal";
import { createFormModalMixin, createFormItemMixin } from "../../../../dt-plugins/form-modal/form-modal";
import { LabelSettingsService } from "../../services/label-settings.service";
import { getVatTypes } from "../../models/invoice-line.model";
import { createTextFieldConfig } from "../../../../plugins/text-field";
import NTable from "@/plugins/datatable/datatable";
import { createNTableConfig } from "../../../../plugins/datatable";
import { uuidv4 } from '../../../../utility';
import { map, prop } from 'ramda';

export default {
  components: {
    Modal,
    NTable
  },
  props: {},
  mixins: [
    createFormModalMixin(),
    createFormItemMixin({
      primary_key: "price_list_id",
      itemKey: "price_list",
      detailsHttpReq: LabelSettingsService.findPriceListDetails,
      addHttpReq: LabelSettingsService.findAddPriceListDetails,
      submitItemGetter: 'getSubmitPriceList',
      processAddHttpResMethod: 'processAddHttpRes'
    }),
  ],
  data: function() {
    return {
      vatT_types: getVatTypes(),

      textFieldConfig: createTextFieldConfig({
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false
      }),

      formValidation: {},

      new_related_codes: []
    };
  },
  computed: {
    currenciesTV: function() {
      return (this.details?.currencies || []).map(c => ({
        text: c.currency_name,
        value: c.currency_id
      }));
    },
    price_codesTV: function() {
      return (this.details?.price_codes || []).map(c => ({
        text: c.price_code_name,
        value: c.price_code_id
      }));
    },
    related_codes_array: function() {
      return [
        ...this.details?.related_codes || [],
        ...this.new_related_codes || [],
      ];
    },
    related_codes_with_new: function() {
      return [
        ...this.related_codes_array,
        {
          price_code_id: uuidv4(),
          price_code_name: '',
          price: '',
        }
      ]
    }
  },
  methods: {
    createNTableConfig: createNTableConfig,
    get_price_list: function() {
      return {
        currency_minus_trailing: null,
        currency_k_sep: null,
        currency_iso: null,
        currency_d_sep: null,
        label: null,
        currency_name: null,
        price_list_notes: null,
        value: null,
        currency_sign_type: null,
        exchange_rate: null,
        currency_id: null,
        currency_sign: null,
        created: null,
        currency_decimals: null,
        last_modified: null,
        price_list_name: null,
        price_list_id: null,
        currency_minus_leading: null
      };
    },
    processAddHttpRes: function() {
      console.log(this.details?.currencies?.[0]?.currency_id);
      this.price_list.currency_id = this.details?.currencies?.[0]?.currency_id;
    },
    onValidationDone: function(id, validationResult) {
      this.formValidation = {
        ...this.formValidation,
        [id]: validationResult
      };
    },
    isFormValid: function() {
      return Object.keys(this.formValidation)
        .map(key => this.formValidation[key].valid)
        .every(e => e);
    },
    onDeletePriceCode: function(item) {
      const {price_code_id} = item;

      this.details.related_codes = this.details.related_codes && this.details.related_codes.filter(l => l.price_code_id != price_code_id);
      this.new_related_codes = this.new_related_codes && this.new_related_codes.filter(l => l.price_code_id != price_code_id);
    },
    onPriceCodeChange: function(item, name, value) {
      console.log(item, name, value);
      console.log(this.details?.related_codes);

      if (this.isNewPriceId(item.price_code_id)) {
        item[name] = value.value;
        this.new_related_codes = [
          ...this.new_related_codes || [],
          item,
        ];
      } else {
        item[name] = value.value;
      }
    },
    isNewPriceId: function(value) {
      return typeof value === 'string' && value.length === 36;
    },
    onTextInputBlur: function(item, name, event) {
      const value = event.target.value;
      item[name] = value;
    },
    getSubmitPriceList: function() {
      return {
        price_list_id: this.price_list_id,
        price_list_name: this.price_list.price_list_name,
        currency_id: this.price_list.currency_id,
        price_code_ids: this.related_codes_array.map(c => c.price_code_id).join(','),
        prices: this.related_codes_array.map(c => c.price).join(','),
      };
    },
    addAllPriceCodes: function() {
      const new_price_codes = this.details.price_codes.filter(p => !map(prop('price_code_id')) (this.related_codes_array).includes(p.price_code_id))
      this.new_related_codes = [
        ...(this.new_related_codes || []),
        ...new_price_codes
      ];
    },
    //MARK: Methods
  }
};
</script>

<style lang="scss">
.cmp-settings-label-price-list-form {
  .related_codes_list {
    --ntable-height: 200px;
    border: 1px solid rgba(128, 128, 128, 0.158);
  }
}
</style>
